module.exports = __webpack_public_path__ + "static/media/unsplash.e4bc0763.jpg";